import type { UIStringsOverride } from "../i18n-ui.ts";

/** Italian (it) UI strings. */
export const it: UIStringsOverride = {
  actions: {
    addToCursor: "Aggiungi a Cursor",
    addToVscode: "Aggiungi a VS Code",
    askAI: "Chiedi all'IA di questa pagina",
    connectMcp: "Connetti a MCP",
    copied: "Copiato!",
    copyClaudeCode: "Copia comando di Claude Code",
    copyCode: "Copia codice",
    copyCodex: "Copia comando di Codex",
    copyMarkdown: "Copia come Markdown",
    copyServerUrl: "Copia URL del server",
    edit: "Modifica su GitHub",
    export: "Esporta",
    exportEpub: "Esporta in EPUB",
    exportPdf: "Esporta in PDF",
    generating: "Generazione in corso…",
    openIn: "Apri in {name}",
    openInChat: "Apri nella chat",
    scrollToTop: "Torna su",
  },
  ask: {
    ai: "IA",
    clear: "Cancella la conversazione",
    close: "Chiudi",
    copy: "Copia la conversazione",
    empty: "Fai una domanda sulla documentazione.",
    error: "Spiacenti, qualcosa è andato storto.",
    label: "Fai una domanda",
    placeholder: "Fai una domanda…",
    send: "Invia",
    tip: "Suggerimento: puoi aprire e chiudere la chat con",
    title: "Chiedi all'IA",
    you: "Tu",
  },
  banner: { dismiss: "Chiudi l'annuncio" },
  changelog: {
    description: "Aggiornamenti del prodotto e note di rilascio.",
    showReleases: "Mostra le versioni {version}",
    title: "Registro delle modifiche",
  },
  content: {
    diagramError: "Impossibile visualizzare questo diagramma.",
  },
  feedback: {
    no: "No",
    question: "Questa pagina ti è stata utile?",
    thanks: "Grazie per il tuo feedback!",
    yes: "Sì",
  },
  languageSwitcher: { label: "Lingua", untranslated: "Non tradotto" },
  nav: {
    back: "Indietro",
    breadcrumb: "Percorso di navigazione",
    closeNavigation: "Chiudi la navigazione",
    deprecated: "deprecato",
    featured: "In evidenza",
    githubRepository: "Repository GitHub",
    navigation: "Navigazione",
    primary: "Principale",
    sections: "Sezioni",
    toggleNavigation: "Mostra o nascondi la navigazione",
    toggleTheme: "Cambia il tema colore",
  },
  notFound: {
    description: "Non siamo riusciti a trovare la pagina che cerchi.",
    home: "Torna alla home",
    title: "Pagina non trovata",
  },
  page: {
    lastUpdated: "Ultimo aggiornamento il",
    next: "Successivo",
    pagination: "Paginazione",
    previous: "Precedente",
    skipToContent: "Vai al contenuto",
  },
  search: {
    all: "Tutti",
    allLanguages: "Tutte le lingue",
    askAi: "Chiedi all'IA",
    askAiHint: "Ottieni una risposta immediata dall'IA",
    button: "Cerca",
    devOnly: "La ricerca è disponibile nella build di produzione.",
    error: "Qualcosa è andato storto. Riprova.",
    label: "Cerca nella documentazione",
    navigate: "naviga",
    noResults: "Nessun risultato trovato.",
    open: "apri",
    placeholder: "Cerca nella documentazione…",
    popular: "Popolari",
    preview: "anteprima",
    results: "Risultati",
  },
  toc: { title: "In questa pagina" },
};
